import React, { useEffect } from 'react';
import CjyxLayout from '../CjyxLayout';
import EmptyLayout from '../EmptyLayout';
import CrmLayout from '../CrmLayout';
import Header from './components/Header';
import styles from './index.module.scss';
import { asideMenuConfig } from '../CrmLayout/menuConfig';

export default function FrameworkLayout(props: {
  children: React.ReactNode;
  pathname: string;
  appLeave: { path: string };
  appEnter: { path: string };
}) {
  const { pathname, children, appLeave, appEnter } = props;

  const category = pathname.split('/')[2];
  const layout = asideMenuConfig.find((menuConfig) => menuConfig.category === category)?.layout;

  const Layout = pathname === '/web/crm/dashboard' ? EmptyLayout : (layout === 'crm' ? CrmLayout : CjyxLayout);

  useEffect(() => {
    console.log('== app leave ==', appLeave);
    // @ts-ignore
    // remove webpackJsonp added by Angular app
    delete window.webpackJsonp;
  }, [appLeave]);

  useEffect(() => {
    console.log('== app enter ==', appEnter);
  }, [appEnter]);

  return (
    <div className={styles.frameworkLayout}>
      <Header {...props} />
      <Layout {...props}>{children}</Layout>
    </div>
  );
}
